module.exports = __webpack_public_path__ + "media/images/igIcon-9a788ab9.svg";